const table = [
    {
        prop: 'CodeDpto',
        label: 'Cod. Dpto.',
        minWidth: 100
    },
    {
        prop: 'Dpto',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'CodeMunicipio',
        label: 'Cod. Munic.',
        minWidth: 100
    },
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'Fecha',
        label: 'Fecha',
        minWidth: 150
    },
    {
        prop: 'VelSubida',
        label: 'Vel. Subida',
        minWidth: 150
    },
    {
        prop: 'VelBajada',
        label: 'Vel. Bajada',
        minWidth: 150
    },
    {
        prop: 'Host',
        label: 'Host',
        minWidth: 150
    },
    {
        prop: 'Descripcion',
        label: 'Descripción',
        minWidth: 100
    },
]

export default table
